'use strict';

var React = require('react');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
require('prop-types');
var ReviewItem = require('./ReviewItem.js');
var Divider = require('../../node_modules/@material-ui/core/esm/Divider/Divider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ReviewItems(_ref) {
  var reviews = _ref.reviews,
      showDivider = _ref.showDivider;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 32,
    direction: "column"
  }, reviews.map(function (review, index) {
    return React__default["default"].createElement(React.Fragment, {
      key: "".concat(review.name).concat(review.date).concat(index)
    }, React__default["default"].createElement(Grid, {
      item: true
    }, React__default["default"].createElement(ReviewItem, review)), showDivider && React__default["default"].createElement(Grid, {
      item: true
    }, React__default["default"].createElement(Divider["default"], null)));
  }));
}
ReviewItems.defaultProps = {
  showDivider: false
};

module.exports = ReviewItems;
